import ct from "class-types.macro";
import React from "react";
import SocialMediaShareButton from "./SocialMediaShareButton";
import { SocialMediaShareData } from "./SocialMediaShareData";

interface Props {
  socialMediaButtons: SocialMediaShareData[];
}

export default function ShareButtons({ socialMediaButtons }: Props) {
  return (
    <div
      className={`${ct(
        "flex",
        "flex-row",
        "float-left",
      )} pull-left custom-social`}
    >
      {socialMediaButtons?.map((button) => (
        <SocialMediaShareButton
          key={button.site}
          site={button.site}
          shareUrl={button.shareUrl}
          showButtonText={false}
          iconHeightWidth="14"
          svgClassName="m-0"
        />
      ))}
    </div>
  );
}
